import { Colors } from '@Constants';
import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { media } from '../style-utils';

export class AccordionItem extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      height: 0,
    };
  }

  componentDidMount() {}

  click = (e) => {
    e.preventDefault();
    let height = this.state.isOpen ? 0 : this.contentElement.offsetHeight;
    this.setState({ isOpen: !this.state.isOpen, height: height });
  };

  render() {
    return (
      <StyledAccordianItem isOpen={this.state.isOpen}>
        <Title onClick={(e) => this.click(e)}>
          {this.props.title}
          <Toggle>
            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12 0a3.066 3.066 0 0 1 3.066 3.066v5.888h5.861a3.073 3.073 0 1 1 0 6.146h-5.86v5.834a3.066 3.066 0 1 1-6.132 0l-.001-5.835H3.073a3.073 3.073 0 0 1 0-6.146h5.86V3.067A3.066 3.066 0 0 1 12 0z"
                fill="currentColor"
                fillRule="evenodd"
              />
            </svg>
          </Toggle>
        </Title>
        <Content style={{ height: this.state.height }}>
          <div ref={(el) => (this.contentElement = el)}>{this.props.children}</div>
        </Content>
      </StyledAccordianItem>
    );
  }
}

const Toggle = styled.span`
  width: 2rem;
  height: 2rem;
  display: block;
  color: var(--colorPrimaryMedium);
  transition: all 200ms linear;
  transform-origin: center;
  position: absolute;
  top: 50%;
  right: 4.2rem;

  svg {
    display: block;
    max-width: 100%;
  }

  ${media.desktopAndUp`
    width: 2.4rem;
    height: 2.4rem;
  `};
`;

const StyledAccordianItem = styled.li`
  background-color: ${(props) => (props.isOpen ? Colors.PrimaryLight2 : Colors.PrimaryLight)};
  border-radius: 4.8px;
  margin-bottom: 1.3rem;
  cursor: pointer;
  transition: background-color 250ms ease-out;
  text-align: left;
  padding: 0;

  ${Toggle} {
    transform: translateY(-50%) ${(props) => (props.isOpen ? 'rotate(45deg)' : 'rotate(0)')};
    opacity: ${(props) => (props.isOpen ? '0.5' : '1')};
  }
`;

const Title = styled.a`
  display: block;
  color: var(--colorPrimaryMedium);
  font-size: 2.2rem;
  letter-spacing: -0.05rem;
  line-height: 2.6rem;
  font-weight: 600;
  padding: 3.4rem 10rem 3.8rem 4.2rem;
  text-decoration: none !important;
  position: relative;

  ${media.desktopAndUp`
    font-size: 3.2rem;
    letter-spacing: -0.04rem;
    line-height: 3.8rem;
  `};
`;

const Content = styled.div`
  font-size: 1.8rem;

  letter-spacing: 0;
  height: 0;
  overflow: hidden;
  transition: height 200ms ease-in-out;
  opacity: 0.8;
  color: ${Colors.PrimaryDark};
  letter-spacing: -0.0227em;
  line-height: 1.4em;
  & > div {
    padding: 0 4.2rem 3.8rem;
  }

  ${media.desktopAndUp`
    font-size: 2.2rem;
  `}

  ol,
  ul {
    margin-top: 2rem;
    margin-bottom: 2rem;
    margin-left: 4rem;
    li {
      margin-bottom: 1.3rem;
    }
  }

  ol {
    list-style: decimal;
  }

  ul {
    list-style: disc;
  }

  & a,
  & a:active,
  & a:focus,
  & a:link,
  & a:visited {
    transition-property: color;
    transition-duration: var(--medium-transition-duration);
    transition-timing-function: var(--medium-transition-function);
    color: var(--colorPrimaryMedium);
  }
  & a:hover {
    color: var(--colorPrimaryDark);
  }

  ${media.tabletLandscapeAndUp`
    max-width: 83%;
  `};
`;

const StyledAccordion = styled.ul`
  list-style: none;
  margin-top: 0;
  margin-bottom: 0;
  color: #076b85;
  max-width: 100%;

  ${media.tabletLandscapeAndUp`
    max-width: 96.5rem;
    margin-left: auto;
    margin-right: auto;
  `};
`;

export const Accordion = StyledAccordion;



// WEBPACK FOOTER //
// ./src/components/Accordion/Accordion.js